import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Card, CardContent } from "@/components/ui/card"
import { useAuth } from "@/modules/Auth/context/AuthContext"
import { getExtratoEmpresa } from "@/services/companyService"
import { EmpresaExtrato } from "@/types/company"
import { useEffect, useState } from "react"

interface ProgressoDetailsModalProps {
  id_grupo: number
  onClose: () => void
}

export function ProgressoDetailsModal({ id_grupo, onClose }: ProgressoDetailsModalProps) {
  const { user } = useAuth()
  const [extrato, setExtrato] = useState<EmpresaExtrato[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (user?.empId) {
      getExtratoEmpresa(user.empId, { grupo: String(id_grupo) })
        .then((response) => {
          setExtrato(response.data)
          setLoading(false)
        })
        .catch(() => {
          setError("Erro ao buscar dados do extrato.")
          setLoading(false)
        })
    }
  }, [user, id_grupo])

  return (
    <Dialog
      open={true}
      onOpenChange={onClose}
    >
      <DialogContent className="max-h-[90vh] overflow-auto sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Detalhes do Consumo</DialogTitle>
        </DialogHeader>
        {loading ? (
          <p>Carregando...</p>
        ) : error ? (
          <p className="text-red-500">{error}</p>
        ) : (
          <div className="max-h-[60vh] space-y-4 overflow-y-auto">
            {extrato.map((item) => (
              <Card key={item.id_participacao}>
                <CardContent className="p-4">
                  <p className="font-semibold">{item.nome_pessoa}</p>
                  <p className="text-sm text-muted-foreground">{item.produto}</p>
                  <p className="text-sm text-muted-foreground">
                    {new Date(item.data_cadastro).toLocaleDateString()}
                  </p>
                  <p className="text-sm">{item.descricao_participacao}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
